import { observer } from "mobx-react-lite";
import { OverlayPrimary } from "../OverlayPrimary/OverlayPrimary/OverlayPrimary";
import { dataBaseStore } from "@/stores/DataBaseStore";
import { useEffect, useState } from "react";
import { DefaultLoader } from "@/components/loaders/DefaultLoader/DefaultLoader";
import { OverlayError } from "../OverlayError/OverlayError/OverlayError";

export const DashBoardLayout = observer(() => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    dataBaseStore.dbConnected();
  }, []);

  if (dataBaseStore.waitingStatusDBConnected || showLoader) {
    return (
      <DefaultLoader
        elementIsReady={!dataBaseStore.waitingStatusDBConnected}
        callBackEndAnimation={() => setShowLoader(false)}
      />
    );
  }

  if (dataBaseStore.success) {
    return <OverlayPrimary />;
  } else {
    return <OverlayError />;
  }
});
